import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledCrossSVG = styled.svg<IconProps>`
  & .cls-1 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--du-color-grey-pale, #f8f8f8);
  }

  &:hover,
  &.active {
    .cls-2 {
      fill: var(--du-color-primary, #128370);
      stroke: var(--du-color-primary, #128370);
    }
  }
`;

const CrossIconLarge: React.FC<IconProps> = ({ active }) => {
  const activeclass = active ? 'active' : undefined;
  return (
    <StyledCrossSVG
      id='Cross-Icon-SVG'
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      className={activeclass}
    >
      <g id='Cross_PDF' data-name='Cross PDF' transform='translate(0 40.001) rotate(-90)'>
        <rect id='Rectangle_5239' data-name='Rectangle 5239' className='cls-1' width='40.001' height='40.002' />
        <path
          id='Path_8818'
          data-name='Path 8818'
          className='cls-2'
          d='M30,12.222,27.778,10,20,17.778,12.222,10,10,12.222,17.778,20,10,27.779,12.222,30,20,22.223,27.778,30,30,27.779,22.223,20Z'
          transform='translate(-1.25 0.001)'
        />
      </g>
    </StyledCrossSVG>
  );
};

export default CrossIconLarge;
